import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Storage from '@/amplify/storage';

const TRANSPARENT_1X1 = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

const urlCache = new Map();

const loadUrl = async (key, level) => {
    const cacheKey = `${level || 'public'}:${key}`;
    if (urlCache.has(cacheKey)) {
        return urlCache.get(cacheKey);
    }
    const url = await Storage.get(key, { level: level || 'public' });
    urlCache.set(cacheKey, url);
    return url;
};

/**
 * Thay thế <S3Image> của aws-amplify-react@3 (EOL, không có bản cho Amplify v6).
 *
 * Giữ nguyên DOM mà bản gốc render - hai div lồng nhau và một div overlay rỗng - vì CSS
 * hiện tại phụ thuộc vào cấu trúc đó: `.fixed-with-avatar > img` là selector con trực tiếp
 * nên KHÔNG áp dụng cho img nằm sâu bên trong. Phẳng hoá cấu trúc sẽ đổi kích thước avatar.
 *
 * Bản gốc cũng bỏ qua prop `width` và `title` (không truyền xuống <img>). Giữ nguyên hành vi
 * đó để không đổi giao diện; nếu muốn hiện tooltip/kích thước thì xử lý như một thay đổi UX riêng.
 */
const S3Image = ({ imgKey, path, level, className, style, onClick, onLoad, onError }) => {
    const [src, setSrc] = useState(TRANSPARENT_1X1);
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        const key = imgKey || path;
        if (!key) {
            return;
        }
        loadUrl(key, level)
            .then(url => {
                if (isMounted.current && url) {
                    setSrc(url);
                }
            })
            .catch(() => {
                /* bản gốc chỉ logger.debug(err) rồi giữ nguyên ảnh trong suốt */
            });
    }, [imgKey, path, level]);

    if (!src) {
        return null;
    }

    return (
        <div style={style || {}}>
            <div style={{ position: 'relative' }} onClick={onClick}>
                <img className={className} src={src} alt="" onLoad={onLoad} onError={onError} />
                <div></div>
            </div>
        </div>
    );
};

S3Image.propTypes = {
    imgKey: PropTypes.string,
    path: PropTypes.string,
    level: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    onLoad: PropTypes.func,
    onError: PropTypes.func
};

export default S3Image;
